import { getLocalActiveStrutturaId } from "./activeStrutturaLocal";

/** Aggiunge token e struttura attiva locale a URL usati in iframe/download (?token=). */
export function appendAuthToUrl(url, token) {
  const separator = url.includes("?") ? "&" : "?";
  let result = `${url}${separator}token=${encodeURIComponent(token)}`;
  const activeId = getLocalActiveStrutturaId();
  if (activeId) {
    result += `&active_struttura_id=${encodeURIComponent(activeId)}`;
  }
  return result;
}

/** Header per fetch autenticate (allineati all'interceptor axios). */
export function buildAuthFetchHeaders(token) {
  const headers = { Authorization: `Bearer ${token}` };
  const activeId = getLocalActiveStrutturaId();
  if (activeId) {
    headers["X-Active-Struttura-Id"] = activeId;
  }
  return headers;
}
